import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 5.955V15.5H2V.5h6.667C12.667.5 14 1.864 14 5.955m-2.013.043-.99-.99-3.999 4-2-2-.99.99 2.99 2.99z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedFilledSize16Glyph.displayName = 'DocumentVerifiedFilledSize16Glyph';
